import { isString, replace } from './lodash.utils'

export const CANDIDATE_URL =
	process.env.REACT_APP_CANDIDATE_URI ||
	process.env.NEXT_PUBLIC_CANDIDATE_URI ||
	'https://me.merify.com'
export const HIRING_URL =
	process.env.REACT_APP_HIRING_URI ||
	process.env.NEXT_PUBLIC_HIRING_URI ||
	'https://match.merify.com'

export const isExternalLink = (link?: string) => (link ? link.substring(0, 4) === 'http' : false)

export const parseQueryParams = (search: string | { search?: string }): { [x: string]: string } => {
	const s = isString(search) ? search : search?.search || '' // might be the location object

	const queryString = replace(s, '?', '')

	if (queryString.length)
		return queryString.split('&').reduce((obj: any, curr: string) => {
			const [query, param] = curr.split('=')

			obj[query] = decodeURIComponent(param)
			return obj
		}, {})

	return {}
}
